import { render, staticRenderFns } from "./Lgx333249633964785664.vue?vue&type=template&id=5f74c802&scoped=true&"
import script from "./Lgx333249633964785664.vue?vue&type=script&lang=js&"
export * from "./Lgx333249633964785664.vue?vue&type=script&lang=js&"
import style0 from "./Lgx333249633964785664.vue?vue&type=style&index=0&id=5f74c802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f74c802",
  null
  
)

export default component.exports